jQuery(function($){
	$('.scfe-modal-wrapper.open-page-load').each(function(e){
		openModal($(this));
	});

	$(document).on('click', '.scfe-modal-trigger[target]', function(e){
		e.preventDefault();

		const target = $(this).attr('target');
		console.log(target);
		openModal($(target));
	});

	$(document).on('click', '.scfe-modal-close', function(){
		closeModal($(this));
	});

	$(document).on('click', '.scfe-modal-background', function(){
		closeModal($(this));
	});

	function openModal(target) {
		target.addClass('showing');
	}

	function closeModal(el) {
		const target = el.closest('.scfe-modal-wrapper');
		target.removeClass('showing');

		//Stop SC Videos
		const iframes = target.find('.sc-video-player iframe');
		if(iframes.length) {
			iframes.each(function(){
				$(this).remove();
			});
		}

		const audio = target.find('audio');
		if(audio.length) {
			audio.each(function(){
				this.pause();
			});
		}
	}
});